/** Preserve the course canvas while retaining the server's exact record address.
 * Only presentation context is copied. Another course or owner URL is untouched. */
export function courseAssignmentContextHref(href: string, pathname: string, search: string): string {
  const origin = "https://course-context.invalid";
  let destination: URL;
  try { destination = new URL(href, origin); } catch { return href; }
  if (destination.origin !== origin || destination.pathname !== pathname || !destination.searchParams.has("assignment")) return href;
  const current = new URLSearchParams(search);
  for (const key of ["view", "session"]) {
    if (current.getAll(key).length === 1) destination.searchParams.set(key, current.get(key)!);
  }
  return `${destination.pathname}?${destination.searchParams}${destination.hash}`;
}
